import React from 'react';
import { Link, useLocation } from 'react-router-dom';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const location = useLocation();

  const isActive = (path: string) => {
    return location.pathname === path;
  };

  return (
    <>
      <header>
        <nav className="navbar navbar-expand-sm navbar-toggleable-sm navbar-light bg-white border-bottom box-shadow mb-5 fixed-top">
          <div className="container">
            <Link className="navbar-brand d-flex align-items-center" to="/">
              <i className="bi bi-bank2 me-2 text-datadog-purple"></i>
              Bitsburg Bank
            </Link>
            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target=".navbar-collapse"
              aria-controls="navbarSupportedContent"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon"></span>
            </button>
            <div className="navbar-collapse collapse d-sm-inline-flex justify-content-between">
              <ul className="navbar-nav flex-grow-1">
                <li className="nav-item">
                  <Link className={`nav-link ${isActive('/') ? 'active' : 'text-dark'}`} to="/" id="nav-home-link">
                    Home
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className={`nav-link ${isActive('/login') ? 'active' : 'text-dark'}`}
                    to="/login"
                    id="nav-login-link"
                  >
                    Login
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className={`nav-link ${isActive('/enroll') ? 'active' : 'text-dark'}`}
                    to="/enroll"
                    id="nav-enroll-link"
                  >
                    Enroll
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className={`nav-link ${isActive('/loan') ? 'active' : 'text-dark'}`}
                    to="/loan"
                    id="nav-loan-link"
                  >
                    Auto Loans
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className={`nav-link ${isActive('/payment') ? 'active' : 'text-dark'}`}
                    to="/payment"
                    id="nav-payment-link"
                  >
                    Make a Payment
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </nav>
      </header>

      <div className="container body-content">
        <main role="main" className="pb-3">
          {children}
        </main>
      </div>
    </>
  );
};

export default Layout;
